import React, { FunctionComponent } from 'react';
import {
  CalculatorAdditionalPaymentFormFields,
  CalculatorAdditionalPaymentResultData
} from './types';
import { useFormContext } from '../../../../hooks';
import { utilsAdditionalPaymentGetTranslationFormOptions } from './utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { utilNumberToCurrency, utilStringToNumber } from '../../../../utils';

interface CalculatorAdditionalPaymentSummaryProps {
  result: CalculatorAdditionalPaymentResultData | Record<string, string>;
}

export const CalculatorAdditionalPaymentSummary: FunctionComponent<
  CalculatorAdditionalPaymentSummaryProps
> = ({ result }) => {
  if (!result) {
    return null;
  }
  const { form } = useFormContext<
    CalculatorAdditionalPaymentResultData,
    CalculatorAdditionalPaymentFormFields
  >();
  const intl = useIntl();

  return (
    <>
      <table>
        <caption className={`text-left mb-4`}>
          <FormattedMessage id={`summary.title`} defaultMessage={'Ingevoerde gegevens'} />
        </caption>
        <tbody>
          <tr>
            <th scope="row">
              <FormattedMessage id={`summary.mortgageType`} defaultMessage={'Hypotheekvorm(en)'} />
            </th>
            <td>
              {utilsAdditionalPaymentGetTranslationFormOptions(
                intl,
                'mortgageType',
                form.mortgageType
              )}
            </td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.remainingTerm`}
                defaultMessage={'Resterende looptijd'}
              />
            </th>
            <td>25 jaar en 1 maand Resterend</td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.mortgageAmount`}
                defaultMessage={'Resterende hoofddeel'}
              />
            </th>
            <td>{utilNumberToCurrency(utilStringToNumber(form.mortgageAmount), true, 0)}</td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.mortgageInterestRate`}
                defaultMessage={'- hypotheekrente'}
              />
            </th>
            <td>{form.mortgageInterestRate}%</td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.mortgageAmount2`}
                defaultMessage={'Resterende aflossingsvrije deel'}
              />
            </th>
            <td>{utilNumberToCurrency(utilStringToNumber(form.mortgageAmount2), true, 0)}</td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.mortgageInterestRate2`}
                defaultMessage={'- hypotheekrente'}
              />
            </th>
            <td>{form.mortgageInterestRate2}%</td>
          </tr>
          <tr>
            <th scope="row">
              <FormattedMessage
                id={`summary.additionalPayment`}
                defaultMessage={'Extra aflossing'}
              />
            </th>
            <td>{utilNumberToCurrency(utilStringToNumber(form.additionalPayment), true, 0)}</td>
          </tr>
          <tr>
            <th scope="row">Aflossing op</th>
            <td>
              {utilsAdditionalPaymentGetTranslationFormOptions(
                intl,
                'paymentType',
                form.paymentType
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};
